/**
 * StreamingCursor — blinking cursor shown at the tail of streaming assistant
 * bubbles (Plan 05-07b).
 *
 * Blinks at 0.8s cycle via Tailwind animate-pulse. Under prefers-reduced-motion,
 * falls back to a static underscore so the cursor remains visible without motion.
 * Uses motion/react's useReducedMotion hook to read the media query.
 */
import { useReducedMotion } from 'motion/react';

export function StreamingCursor() {
  const reduce = useReducedMotion();
  if (reduce) {
    return (
      <span
        data-testid="assistant-cursor-static"
        className="inline-block text-ink ml-0.5"
      >
        _
      </span>
    );
  }
  return (
    <span
      data-testid="assistant-cursor"
      className="inline-block w-0.5 h-em bg-ink ml-1 animate-pulse"
    />
  );
}
